import React from 'react';
import { Info } from 'lucide-react';

const inr = (n) => `INR ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

// Transparent checkout breakdown; `b` comes from the server (services/event_charges.compute_breakdown).
export const PriceBreakdown = ({ b, baseLabel = 'Registration amount', testId = 'price-breakdown' }) => {
  if (!b || !(b.base_amount > 0)) return null;
  return (
    <div className="rounded-lg border border-[#E4E4E7] bg-white p-3.5 text-sm space-y-1.5" data-testid={testId}>
      <div className="flex justify-between text-[#52525B]"><span>{baseLabel}</span><span data-testid={`${testId}-base`}>{inr(b.base_amount)}</span></div>
      {b.discount > 0 && <div className="flex justify-between text-emerald-600"><span>Coupon discount</span><span data-testid={`${testId}-discount`}>− {inr(b.discount)}</span></div>}
      {b.charges.map((c) => (
        <div key={c.key} data-testid={`${testId}-${c.key}`}>
          <div className="flex justify-between text-[#52525B]">
            <span>{c.label}{c.rate !== 'fixed' && <span className="text-[#A1A1AA]"> ({c.rate})</span>}</span>
            <span className="whitespace-nowrap shrink-0 pl-2">+ {inr(c.amount)}</span>
          </div>
          <p className="text-[11px] text-[#A1A1AA] flex items-start gap-1 leading-snug"><Info size={11} className="mt-0.5 shrink-0" />{c.description}</p>
        </div>
      ))}
      <div className="flex justify-between pt-1.5 border-t border-[#E4E4E7] font-bold text-[#0A0A0A]">
        <span>Total payable</span><span data-testid={`${testId}-total`}>{inr(b.total)}</span>
      </div>
    </div>
  );
};
